var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "__tb" }, [
    _c(
      "div",
      { staticClass: "__tb_row __tb_head __pointer" },
      [
        _vm._l(_vm.$t("tradeOpenOrders.table.heads"), function(h) {
          return _c("div", { key: h, staticClass: "__tb_cell" }, [
            _vm._v("\n            " + _vm._s(h) + "\n        ")
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "__tb_cell" }, [
          _vm._v(_vm._s(_vm.$t("tradeAssets.operate")))
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.sortedList && _vm.sortedList.length,
            expression: "sortedList && sortedList.length"
          }
        ],
        staticClass: "__tb_content"
      },
      _vm._l(_vm.sortedList, function(v) {
        return _c(
          "div",
          {
            key: v.orderId,
            staticClass: "__tb_row __pointer __tb_content_row",
            class: {
              active: !!_vm.changeList[v.orderId]
            }
          },
          [
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(_vm._s(_vm._f("d")(v.createTime)))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(_vm._s(v.tradeTokenSymbol + "/" + v.quoteTokenSymbol))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "__tb_cell",
                class: {
                  buy: v.side === 0,
                  sell: v.side === 1
                }
              },
              [_vm._v(_vm._s(_vm.$t("tradeOrderHistory.side")[v.side]))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(
                _vm._s(v.price + " " + _vm.getOriginSymbol(v.quoteTokenSymbol))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(
                _vm._s(
                  v.quantity + " " + _vm.getOriginSymbol(v.tradeTokenSymbol)
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(
                _vm._s(
                  v.executedQuantity +
                    " " +
                    _vm.getOriginSymbol(v.tradeTokenSymbol)
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(_vm._s((v.executedPercent * 100).toFixed(2) + "%"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(
                _vm._s(
                  v.executedAvgPrice +
                    " " +
                    _vm.getOriginSymbol(v.quoteTokenSymbol)
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__tb_cell" }, [
              _vm._v(
                _vm._s(v.amount + " " + _vm.getOriginSymbol(v.quoteTokenSymbol))
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "__tb_cell click-able",
                on: {
                  click: function($event) {
                    return _vm._cancel(v)
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tradeOpenOrders.table.rowMap.cancel")) +
                    "\n            "
                )
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.sortedList || !_vm.sortedList.length,
            expression: "!sortedList || !sortedList.length"
          }
        ],
        staticClass: "__tb_content __tb_content_no_data"
      },
      [
        _c("div", { staticClass: "__tb_no_data" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("hint.noData")))])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }